import React from 'react';

const CTASection = ({ section }) => {
  const sectionData = section.section_data || {};
  const layout = sectionData.layout || 'centered';
  const buttonStyle = sectionData.button_style || 'primary';
  const size = sectionData.size || 'normal';

  const sizeMap = {
    small: 'btn-sm',
    normal: '',
    large: 'btn-lg'
  };

  const styleMap = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline-primary'
  };

  const alignmentMap = {
    centered: 'center',
    left: 'left',
    right: 'right'
  };

  return (
    <section
      className="cta-section"
      style={{
        backgroundImage: section.image ? `url(${section.image})` : 'none',
        backgroundColor: section.background_color || '#007bff',
        color: section.text_color || '#ffffff',
        padding: '80px 20px',
        textAlign: alignmentMap[layout],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative'
      }}
    >
      {section.image && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 1
          }}
        />
      )}
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {section.title && (
            <h2 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              {section.title}
            </h2>
          )}
          {section.subtitle && (
            <h3 style={{ fontSize: '1.75rem', marginBottom: '1.5rem', opacity: 0.9 }}>
              {section.subtitle}
            </h3>
          )}
          {section.content && (
            <div
              style={{ fontSize: '1.2rem', marginBottom: '2rem', lineHeight: '1.7' }}
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
          {section.button_text && section.button_link && (
            <a
              href={section.button_link}
              className={`btn ${styleMap[buttonStyle]} ${sizeMap[size]}`}
              style={{ marginTop: '1rem', fontSize: '1.1rem', padding: '12px 30px' }}
            >
              {section.button_text}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
